'use client';
import classNames from 'classnames';

import { DeveloperCard } from './DeveloperCard';
import { Developer } from './developers';
import styles from './developersHero.module.scss';
import type * as React from 'react'

export interface HeroColumnProps {
  column: Developer[];
  columnIndex: number;
  duration: number;
}

export const HeroColumn = ({ column, columnIndex, duration }: HeroColumnProps) => (
  <div
    className={classNames(
      styles.column,
      columnIndex % 2 === 1 && styles.columnReverse
    )}
    style={
      {
        '--marquee-duration': `${duration}s`,
      } as React.CSSProperties
    }
  >
    <div className={styles.track}>
      {[...column, ...column].map((dev, cardIndex) => (
        <DeveloperCard
          key={`${dev.firstName}-${dev.lastName}-${cardIndex}`}
          dev={dev}
          ariaHidden={cardIndex >= column.length}
        />
      ))}
    </div>
  </div>
);
